import { z } from "zod";
/**
 * The three frames that make a turn unlosable from the client's side (`D192`).
 *
 * Like {@link TRAINER_ACTIVITY_FRAME} they are not the SDK's `CHAT_FRAME`
 * types, so they carry this app's own prefix, and a client that does not know
 * one falls through its frame switch's `default` and ignores it — an older
 * build loses nothing it had before.
 *
 * ── WHY THE SERVER HAS TO SAY THESE AT ALL ──────────────────────────────────
 * A question resent after a reconnect reuses its own message id, and the SDK's
 * `persistMessages(…, { _deleteStaleRows: true })` deletes every stored row the
 * request did not carry whenever every row it DID carry already exists — so
 * the stored answer to that question was deleted and the turn ran again, write
 * tools and all. The agent now refuses such a request BEFORE the SDK sees it,
 * and these two frames are what it answers instead.
 */
/** The question this request carries is already answered: read the history. */
export const TRAINER_TURN_SETTLED_FRAME = "mypocketgym_turn_settled";
/** The question this request carries is being answered now: wait for it. */
export const TRAINER_TURN_IN_FLIGHT_FRAME = "mypocketgym_turn_in_flight";
/**
 * The client's own visibility, sent on every socket it opens and whenever the
 * app goes to or comes back from the background. The agent reads it to decide
 * whether a finished answer deserves a push: nobody is looking, or the only
 * socket left belongs to an app the person has put away.
 */
export const TRAINER_PRESENCE_FRAME = "mypocketgym_presence";
export const trainerTurnSettledFrame = z.object({
    /** The request id the client sent, so it can tell which turn this ends. */
    id: z.string().min(1),
    type: z.literal(TRAINER_TURN_SETTLED_FRAME),
});
export const trainerTurnInFlightFrame = z.object({
    id: z.string().min(1),
    type: z.literal(TRAINER_TURN_IN_FLIGHT_FRAME),
});
export const trainerPresenceFrame = z.object({
    type: z.literal(TRAINER_PRESENCE_FRAME),
    visible: z.boolean(),
});
//# sourceMappingURL=turn-frames.js.map